import Api from "../api";
import { Contract, ContractAudit } from "@/services/contracts/types";

export async function getContracts(): Promise<Array<Contract >> {
    return new Promise((resolve, reject) => {
        Api.get("/contract").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getContractAudits(actionType: string): Promise<Array<ContractAudit >> {
    return new Promise((resolve, reject) => {
        Api.get(`/contract/history/${actionType}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function syncContracts(): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.get("/contract/sync").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
